import { AIChatCompletion, AIChatCompletionDelta, AIChatCompletionOperationOptions } from "@microsoft/ai-chat-protocol";

export const enum RetrievalMode {
    Hybrid = "hybrid",
    Vectors = "vectors",
    Text = "text"
}

export type ChatAppRequestOverrides = {
    use_advanced_flow?: boolean;
    retrieval_mode?: RetrievalMode;
    top?: number;
    temperature?: number;
    prompt_template?: string;
    username?: string;
    selected_copilot?: string;
    user_context?: string;
};

export type ChatAppRequestContext = {
    overrides: ChatAppRequestOverrides;
};

export interface ChatAppRequestOptions extends AIChatCompletionOperationOptions {
    context: ChatAppRequestContext;
    sessionState?: any; // Session state for conversation context
    session_id?: string; // Session ID for conversation context tracking
}

export type Thoughts = {
    title: string;
    description: any; // It can be any output from the api
    props?: { [key: string]: string };
};

export type RAGContext = {
    data_points: { [key: string]: any };
    followup_questions: string[] | null;
    thoughts: Thoughts[];
    embedded_cars?: any[]; // Store car listings for Videntis mode
};

export interface RAGChatCompletion extends AIChatCompletion {
    context: RAGContext;
    sessionState?: any; // Session state for conversation context
}

export interface RAGChatCompletionDelta extends AIChatCompletionDelta {
    context: RAGContext;
    sessionState?: any; // Session state for conversation context
}

// Chat History Types
export interface ConversationPublic {
    id: string;
    clerk_user_id: string;
    title: string;
    created_at: string;
    updated_at: string;
}

export interface MessagePublic {
    id: number;
    conversation_id: string;
    role: "user" | "assistant";
    content: string;
    created_at: string;
}

export interface ConversationWithMessages extends ConversationPublic {
    messages: MessagePublic[];
}

export interface SaveConversationRequest {
    title?: string;
    messages: Array<{
        role: "user" | "assistant";
        content: string;
    }>;
}
